/**
 * Componenet that display the overview of a specific authorisation
 * @author Liwei Yeh <liwei.yeh@adasasistemas.com>
 */

// Library

// Assets
import { Arrow } from '@public';
// Types
import { AuthorisationSummary } from '@types';
import { AuthorisationDisplayController } from '@utils';

// Styles
import styles from './authorisationItem.module.scss';

/**
 * Props for AuthorisationsItem
 */
export interface AuthorisationItemProp {
	/** Authorisation */
	auth: AuthorisationSummary;
	/** Callback function when this authorisation is clicked */
	onItemClick: (auth: AuthorisationSummary) => void;
	/** Determine whether this authorisation is selected */
	selected: boolean;
}

export const AuthorisationItem = ({ auth, onItemClick, selected }: AuthorisationItemProp) => {
	const authDisplayer = new AuthorisationDisplayController(auth);
	const { labels: authLabels, visible: authVisible, values: authValues } = authDisplayer;

	return (
		<div
			className={[styles.container, selected && styles['container-selected']].join(' ')}
			onClick={() => {
				onItemClick(auth);
			}}
		>
			<div className={styles.brief}>
				<div>
					<p>
						{authLabels.reference}: {authValues.reference}
					</p>
					<p>
						{authLabels.status}: {authValues.status}
					</p>
				</div>
				<div>{authVisible.allocation && <p>Announcement: {authValues.allocation}</p>}</div>
			</div>
			<p className={styles.subgroup}>
				{authLabels.managementSubgroup}: {authValues.managementSubgroup}
			</p>
			<p className={styles.type}>
				{authLabels.type}: {authValues.type}
			</p>
			<div className={styles.separator} />
			<div className={styles['detail-container']}>
				<div />
				<button className={styles.detail}>
					<p>View details</p>
					<Arrow customStyles={styles['detail-icon']} />
				</button>
			</div>
		</div>
	);
};
